import React from 'react'
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';
const PreArrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={`${className} faleft`} onClick={onClick}>
          <CIcon icon="fa-left"></CIcon>
        </div>
    )
}


PreArrow.propTypes = {
     onClick: PropTypes.func,
     className: PropTypes.string,
};

export default PreArrow